"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamsIntegrationTreeView = require("./TeamsIntegrationTreeView");
Object.keys(_TeamsIntegrationTreeView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamsIntegrationTreeView[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamsIntegrationTreeView[key];
    }
  });
});